import * as React from 'react';

const DeclarationDtlsItem = (props) => {

    return(
        <div className="row around-xs inputPair elementVisible">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div style={{width:'100%',paddingLeft:'5%'}}>
                <div style={{width:'3%',float:'left'}}>
                    <span style={{height:'7px',width:'7px',borderRadius:'50%',display:'inline-block',backgroundColor:'#495057'}} />    
                </div>
                <div style={{width:'92%',float:'left'}}>
                    <label id={props.id}>{props.lblname} </label> 
                </div>
            </div>
        </div>
        </div>
    )
}

export default DeclarationDtlsItem;